import { Facets, FacetsProps } from 'pages/products/components';
import { Box, withStyles } from '@material-ui/core';
import { SButton, SText } from '@setvi/shared/components';
import { CustomerDropdown } from 'componentsV2/customer-dropdown';
import { CustomerPreferencesInterface } from 'componentsV2/customer-preferences/interfaces';
import { PriceGroupDropdown } from 'componentsV2/price-group-dropdown';
import { COMPANIES } from 'Enums/Companies';
import { CustomerPreferences } from 'componentsV2';
import { useAppContext } from 'Providers/AppProvider/AppContext';
import { ContentContainer, HeaderContainer } from './styled';
import { DrawerHeaderTitle } from '../components';
import { MobileProductsList } from '../../list';

export interface MobileFiltersProps extends FacetsProps {
  filters: MobileProductsList['filters'];
  selectedCustomerPreference: CustomerPreferencesInterface;
  aiSearchActive?: boolean;
  handleClose: () => void;
  setSelectedCustomerPreference: React.Dispatch<
    React.SetStateAction<CustomerPreferencesInterface>
  >;
}

const DropdownTitle = withStyles(({ spacing }) => ({
  root: {
    size: 14,
    fontWeight: 600,
    marginBottom: spacing(2)
  }
}))(SText);

export const MobileFilters = ({
  filters,
  selectedCustomerPreference,
  aiSearchActive,
  handleClose,
  setSelectedCustomerPreference,
  ...rest
}: MobileFiltersProps) => {
  const { user } = useAppContext();

  return (
    <ContentContainer>
      <HeaderContainer>
        <DrawerHeaderTitle title="Filters" handleClose={handleClose} />
        <SButton
          variant="text"
          onClick={() => {
            rest.onSelectFacet(false, rest.selectedFacets);
            filters?.customer?.onChange?.(null);
          }}
          disabled={!rest?.selectedFacets?.length && !filters?.customer?.value}
          style={{ minHeight: 'auto', padding: 0 }}>
          Clear All
        </SButton>
      </HeaderContainer>
      <Box display="flex" flexDirection="column" gridGap="12px" height="100%">
        {filters?.customer?.show && (
          <Box>
            <DropdownTitle title="Customer" />
            <CustomerDropdown
              newDesign
              selectedCustomer={filters?.customer?.value}
              onSelectCustomer={customer => {
                filters?.customer?.onChange(customer);
              }}
              style={{ input: { width: '100%' } }}
            />
          </Box>
        )}
        {filters?.priceGroup?.show && (
          <Box>
            <DropdownTitle title="Price Group" />
            <PriceGroupDropdown
              newDesign
              selectedPriceGroup={filters?.priceGroup?.value}
              style={{ input: { width: '100%' } }}
              onChange={priceGroup => {
                filters?.priceGroup?.onChange(priceGroup);
              }}
            />
          </Box>
        )}
        {!aiSearchActive && COMPANIES.ELANCO_PROD === user?.CompanyID && (
          <Box>
            <DropdownTitle title="Customer" />
            <CustomerPreferences
              newDesign
              style={{ dropdownWrapperWidth: 458 }}
              selected={selectedCustomerPreference}
              onSelect={customer => {
                setSelectedCustomerPreference(customer);
              }}
            />
          </Box>
        )}
        <Box height="100%" overflow="auto">
          <Facets
            {...rest}
            onSelectFacet={(isChecked, facet) => {
              rest.onSelectFacet(isChecked, facet);
            }}
          />
        </Box>
      </Box>
    </ContentContainer>
  );
};
